module.exports = __webpack_public_path__ + "static/media/035.cb700032.png";